import { CSSProperties } from "theme-ui"

export type BorderProps = Pick<
CSSProperties,
"borderWidth" | "borderStyle" | "borderColor"
>;

export const border = ({
  borderWidth = "thin",
  borderStyle = "solid",
  borderColor
}: BorderProps) => {
  return {
    borderWidth,
    borderStyle,
    borderColor
  }
}

export const style = (key: string) => {}
